import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'changeOwnership',
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('change_ownershio_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
      });
    }
  },
}
